import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import textWrap from 'svg-text-wrap'
import chroma from "chroma-js";

function TreeMap(props) {
    const {rectangles, width, height, textColor, rx, highlightedId, highlightDarken} = props;

    const wrappedTextLabel = (label, x, y, rotate, width, height) => {
        const fontSize = 0.7 + Math.min(0.4, width * height / 80000);
        const spacing = 21 * fontSize;
        const pad = spacing / 2;
        let textArray = textWrap(label, (rotate ? height : width) - pad * 2, {'font-size': fontSize + 'em'});
        let maxLines = rotate ? (width / spacing) : (height / spacing);
        maxLines -= 1;//leave 1 line of space between top / bottom as 'padding'
        textArray = textArray.slice(0, maxLines);

        let offset = spacing * (textArray.length - 1) / 2;
        const xPos = (i) => {
            if (rotate) {
                return x - i * spacing + offset;
            }
            return x;
        };
        const yPos = (i) => {
            if (!rotate) {
                return y + i * spacing - offset;
            }
            return y;
        };
        const rotation = rotate ? 90 : 0;
        return (<Fragment>
            {textArray.map((txt, i) => <text key={'txt'+i} fontSize={fontSize + 'em'} fill={textColor} x={xPos(i)} y={yPos(i)}
                                             transform={`rotate(${rotation}, ${xPos(i)}, ${yPos(i)})`}
                                             dominantBaseline="middle" textAnchor="middle">
                {txt}
            </text>)}
        </Fragment>);
    };
    const verticalText = (width, height) => {
        return height / width > 1.5;
    };
    const adjust = (id, fill) => {
        let color = chroma(fill);
        if (highlightedId === '') {
            return color;
        }
        if (highlightedId === id) return color.darken(highlightDarken);
        return color;
    };
    return (
        <svg width={width} height={height}>
            <g className={'TreeMap'}>
                {rectangles.map(({id, x, y, width, height, color, label}, i) =>
                    <g key={`r_${i}`}>
                        <rect stroke={'#ffffff'} rx={rx} fill={adjust(id, color)} x={x} y={y} width={width}
                              height={height}/>
                        {wrappedTextLabel(label, x + width / 2, y + height / 2, verticalText(width, height), width, height)}
                    </g>
                )}
            </g>
        </svg>
    );
}

TreeMap.defaultProps = {
    width: 400,
    height: 400,
    textColor: '#ffffff',
    highlightedId: '',
    highlightDarken: 0.5,
    rx: 0
};

export default observer(TreeMap);







